var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgManinPeace = function SvgManinPeace(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 940,
    height: 440,
    viewBox: "0 0 940 440",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "26c0c907-6fff-416d-a98a-b40c07c88d13",
    x1: 261.04,
    y1: 155.97,
    x2: 723.8,
    y2: 155.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7f6c1022-f147-4419-bf4c-861cc520211c",
    x1: 650,
    y1: 190.77,
    x2: 665.49,
    y2: 190.77,
    xlinkHref: "#26c0c907-6fff-416d-a98a-b40c07c88d13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d044d528-8c05-4526-90da-4daafb2253b4",
    x1: 551.18,
    y1: 124.33,
    x2: 576.07,
    y2: 124.33,
    xlinkHref: "#26c0c907-6fff-416d-a98a-b40c07c88d13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9dceb057-73d9-4ed3-a42f-81feb98a1d2b",
    x1: 387.5,
    y1: 205.53,
    x2: 393.33,
    y2: 205.53,
    xlinkHref: "#26c0c907-6fff-416d-a98a-b40c07c88d13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2ae92164-21af-4efc-bb85-7045e5c1637c",
    x1: 260.54,
    y1: 155.97,
    x2: 724.3,
    y2: 155.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0e5f0a97-04fc-406f-be9f-79aee0bfa584",
    x1: 346.02,
    y1: 96.56,
    x2: 382.17,
    y2: 96.56,
    xlinkHref: "#2ae92164-21af-4efc-bb85-7045e5c1637c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbce8402-874e-48b9-a155-ac8b3a108125",
    x1: 649.56,
    y1: 190.67,
    x2: 665.77,
    y2: 190.67,
    xlinkHref: "#2ae92164-21af-4efc-bb85-7045e5c1637c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dc65b9fc-0fe0-4514-a98e-4c0c99173beb",
    x1: 550.71,
    y1: 124.21,
    x2: 576.34,
    y2: 124.21,
    xlinkHref: "#2ae92164-21af-4efc-bb85-7045e5c1637c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adfb749c-2e97-40b8-aedf-5d275c909c2c",
    x1: 387,
    y1: 205.62,
    x2: 393.77,
    y2: 205.62,
    xlinkHref: "#2ae92164-21af-4efc-bb85-7045e5c1637c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc24e7fb-140f-40f6-b4fd-5d5c0604e576",
    x1: 616.39,
    y1: 331.55,
    x2: 815.9,
    y2: 331.55,
    xlinkHref: "#26c0c907-6fff-416d-a98a-b40c07c88d13"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-peace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "381ce214-9e55-4b3d-a744-4248e8b14131",
    "data-name": "figures and interactions"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M723.59,213.62c-2.34-19.65-19.79-31.36-19.79-31.36h0c-4.39-3.29-11.29-5.42-19-5.42s-14.88,2.19-19.26,5.58c-1.08.71-2.08,1.44-3,2.17-.63-8.06-2.45-29.23-2.61-30.13-3.37-28.34-28.53-45.21-28.53-45.21h0c-6.33-4.75-16.27-7.81-27.45-7.81-11.37,0-21.46,3.16-27.77,8a66.7,66.7,0,0,0-18.87,18.25,53.25,53.25,0,0,0-13.07-13.65h0c-4.39-3.29-11.29-5.42-19-5.42s-14.88,2.19-19.26,5.58a50.25,50.25,0,0,0-7.1,5.62c-11.91-27.93-35.81-44-35.81-44h0c-9.29-7-23.87-11.46-40.27-11.46-16.68,0-31.48,4.64-40.74,11.81A99.3,99.3,0,0,0,356.37,100q-1,0-2,0c-11.37,0-21.46,3.16-27.77,8-30.3,19.93-28.51,48.32-28.51,48.32a19.18,19.18,0,0,0,.42,3.9c-7.22.28-13.57,2.39-17.65,5.55-21,13.82-19.78,33.51-19.78,33.51,0,12.45,17.48,22.55,39,22.55,14.67,0,27.45-4.68,34.12-11.59,9.87,4.93,22.73,7.92,36.8,7.92a92.48,92.48,0,0,0,22.32-2.66c11.24,18.63,41.89,32,78,32,19.73,0,37.84-4,52-10.67a88.34,88.34,0,0,0,30,5c21.78,0,40.66-7.15,50-17.61a62.76,62.76,0,0,0,18.23,2.61,58.13,58.13,0,0,0,25.3-5.38c4.25,9.79,19.59,17,37.87,17,21.56,0,39-10.09,39-22.55A13.3,13.3,0,0,0,723.59,213.62Z",
    style: {
      fill: "url(#26c0c907-6fff-416d-a98a-b40c07c88d13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.49,182.43A44.72,44.72,0,0,0,650,199.1",
    style: {
      fill: "url(#7f6c1022-f147-4419-bf4c-861cc520211c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.07,109.49c-14.13,9.29-21.28,20.43-24.89,29.67",
    style: {
      fill: "url(#d044d528-8c05-4526-90da-4daafb2253b4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5,195.57s1.33,11.51,5.83,19.92",
    style: {
      fill: "url(#9dceb057-73d9-4ed3-a42f-81feb98a1d2b)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M723.59,213.62c-2.34-19.65-19.79-31.36-19.79-31.36h0c-4.39-3.29-11.29-5.42-19-5.42s-14.88,2.19-19.26,5.58c-1.08.71-2.08,1.44-3,2.17-.63-8.06-2.45-29.23-2.61-30.13-3.37-28.34-28.53-45.21-28.53-45.21h0c-6.33-4.75-16.27-7.81-27.45-7.81-11.37,0-21.46,3.16-27.77,8a66.7,66.7,0,0,0-18.87,18.25,53.25,53.25,0,0,0-13.07-13.65h0c-4.39-3.29-11.29-5.42-19-5.42s-14.88,2.19-19.26,5.58a50.25,50.25,0,0,0-7.1,5.62c-11.91-27.93-35.81-44-35.81-44h0c-9.29-7-23.87-11.46-40.27-11.46-16.68,0-31.48,4.64-40.74,11.81A99.3,99.3,0,0,0,356.37,100q-1,0-2,0c-11.37,0-21.46,3.16-27.77,8-30.3,19.93-28.51,48.32-28.51,48.32a19.18,19.18,0,0,0,.42,3.9c-7.22.28-13.57,2.39-17.65,5.55-21,13.82-19.78,33.51-19.78,33.51,0,12.45,17.48,22.55,39,22.55,14.67,0,27.45-4.68,34.12-11.59,9.87,4.93,22.73,7.92,36.8,7.92a92.48,92.48,0,0,0,22.32-2.66c11.24,18.63,41.89,32,78,32,19.73,0,37.84-4,52-10.67a88.34,88.34,0,0,0,30,5c21.78,0,40.66-7.15,50-17.61a62.76,62.76,0,0,0,18.23,2.61,58.13,58.13,0,0,0,25.3-5.38c4.25,9.79,19.59,17,37.87,17,21.56,0,39-10.09,39-22.55A13.3,13.3,0,0,0,723.59,213.62Z",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      stroke: "url(#2ae92164-21af-4efc-bb85-7045e5c1637c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.89,76.25C362.51,89,352.08,104.1,346.48,117.09",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      stroke: "url(#0e5f0a97-04fc-406f-be9f-79aee0bfa584)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.49,182.43A44.72,44.72,0,0,0,650,199.1",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      stroke: "url(#bbce8402-874e-48b9-a155-ac8b3a108125)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.07,109.49c-14.13,9.29-21.28,20.43-24.89,29.67",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      stroke: "url(#dc65b9fc-0fe0-4514-a98e-4c0c99173beb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5,195.57s1.33,11.51,5.83,19.92",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      stroke: "url(#adfb749c-2e97-40b8-aedf-5d275c909c2c)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201,182.4c14.13,9.29,21.28,20.43,24.89,29.67",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.24,227.37c3.37-28.34,28.53-45.21,28.53-45.21h0c6.33-4.75,16.27-7.81,27.45-7.81,11.37,0,21.46,3.16,27.77,8a66.7,66.7,0,0,1,18.87,18.25A53.25,53.25,0,0,1,232.94,187h0c4.39-3.29,11.29-5.42,19-5.42s14.88,2.19,19.26,5.58a50.25,50.25,0,0,1,7.1,5.62l.09,0q1,0,2,0c11.37,0,21.46,3.16,27.77,8,30.3,19.93,28.51,48.32,28.51,48.32a19.18,19.18,0,0,1-.42,3.9c7.22.28,13.57,2.39,17.65,5.55,21,13.82,19.78,33.51,19.78,33.51,0,12.45-17.48,22.55-39,22.55-14.67,0-27.45-4.68-34.12-11.59,0,0-24,12.4-57,12.4-35,0-60.5-7.9-69.86-18.36a62.76,62.76,0,0,1-18.23,2.61,58.13,58.13,0,0,1-25.3-5.38c-4.25,9.79-19.59,17-37.87,17-21.56,0-39-10.09-39-22.55a13.3,13.3,0,0,1,.21-2.32c2.34-19.65,19.79-31.36,19.79-31.36h0A26.93,26.93,0,0,1,83,250.83l.64-.34a52.92,52.92,0,0,1,15.62-18h0c4.39-3.29,11.29-5.42,19-5.42a40.55,40.55,0,0,1,7,.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M883.07,318.46c-2.34-19.65-19.79-31.36-19.79-31.36h0c-4.39-3.29-11.29-5.42-19-5.42a41.18,41.18,0,0,0-5,.3c-.45-4.57-1.38-12.93-2.29-20.26-3.52-28.32-28.53-45.21-28.53-45.21h0c-6.33-4.75-16.27-7.81-27.45-7.81-11.37,0-21.46,3.16-27.77,8a74.16,74.16,0,0,0-7.83,5.91,44.72,44.72,0,0,0-15.24-2.55c-9.37,0-17.68,2.61-22.88,6.63-25,16.42-23.49,39.81-23.49,39.81,0,12.35,14.46,22.74,34.14,25.83a12.34,12.34,0,0,1,9,6.78c6.81,13.53,28.43,23.42,54,23.42a96.6,96.6,0,0,0,11.63-.7c9,.43,13.38,4.71,14.89,6.58,5.44,8.67,19.82,14.87,36.72,14.87,21.56,0,39-10.09,39-22.55A13.3,13.3,0,0,0,883.07,318.46Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.22,216.75c-30.3,19.93-28.51,48.32-28.51,48.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.24,281.68c-7.89,0-14.88,2.19-19.26,5.58a49.92,49.92,0,0,0-7.69,6.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M524.12,162.21c-7.62,55.91-3.29,135.91-55.51,41.65-2-3.54-7.92-1.48-10.65,1.51-5.54,6.08-4.46,9.91-1.13,18.13,27,66.71,84.34,95.78,95.25-9.52C552.08,214,526.11,147.63,524.12,162.21Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.12,179.16a39.69,39.69,0,0,1,37.53-52.59c-1.59-.36,10.07,1.21,17.55,4,20.39,7.52,50.29,23.62,68.68,32.3,13.82,6.52,26,15.74,34.41,25.53.45.53,1.45,1.95,1.64,2.23,15.66,21.38-23.69,96.24-24.11,102.58,0,.16,0,4.84,0,5,.17,1.08,1,10.88-2.77,15.29-11.41,13.42-38,14.68-64.5-.59C568,298.15,553.72,274.71,560,259c.4-2.12-.19-10.26-.48-12C556.34,228.3,525.12,179.16,525.12,179.16Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.18,158,588,121.72l38.85-.16,0,51.52C626.71,185.66,593.9,174.55,588.18,158Z",
    style: {
      fill: "#9e684d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.72,218.28a.63.63,0,0,0,.91-.31c1.09-2.74,4.83-13,1.2-15.61-8.83-6.42-22.5-9.83-22.5-9.83l-9-2.46a.63.63,0,0,0-.75.87c.84,1.76,3.18,5,9.39,6.41a.64.64,0,0,1,.49.52l1.34,9a.63.63,0,0,0,.31.45Z",
    style: {
      fill: "#9e684d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.32,179.13l-5.49,12-.23,15.53L421,200.15s2.8-3.11,2.94-4.84a13.77,13.77,0,0,0-.47-5.72.71.71,0,0,0-1.27-.15l-7.41,11.32,6.48,11.6a7.85,7.85,0,0,0,4.59,3.69c4.55,1.37,12.86,3.8,15.62,4.07,15.65,1.53,22.22-4.45,24.83-8.46a6.73,6.73,0,0,0-.25-7.86c-2.46-3.09-8.19-5.39-21.46,2.4l-1.83-11.08s.67-2.88.88-4.75a4.56,4.56,0,0,0-1.19-3.36.33.33,0,0,0-.55.09l-2.57,6.47-.26,13.22-2.33-16.15s4.26-6.42,2.71-10a.39.39,0,0,0-.69,0l-6.39,9.91-.62,15-1.57-15s4.43-9,2-11.5A.58.58,0,0,0,431.32,179.13Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "2ddfe197-d5cb-468e-93e7-d1165ec8e1db",
    "data-name": "<Path>",
    d: "M626.77,135.41c-4.53,9-16.9,16.81-25.2,17.76a36.78,36.78,0,0,1-13.48-.57l0-23.67,38.73-3.74Z",
    style: {
      fill: "#b7835f",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.41,112.17l-3.61-31.93-48.55,3.11s-5.27,36.41,4.67,58.28h0c.12.27.26.54.41.8,4.49,7.77,19,7.78,32.5,0a32.42,32.42,0,0,0,15.61-20.84c.28-1.31-1.48-1-1.57-2.18-.11-1.54,2.21-5.12,2.21-5.12A9.67,9.67,0,0,0,626.41,112.17Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 626.39,
    cy: 116.9,
    rx: 1.54,
    ry: 2.66,
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.64,135.3a.74.74,0,0,0,.08,1.39,25.27,25.27,0,0,0,6.92.51c4.33-.1,5.75-1.37,5.75-1.37s-3.67.87-6.15.11c-1.08-.33-3-1-4.42-.44A2.3,2.3,0,0,0,584.64,135.3Z",
    style: {
      fill: "#b7835f",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.24,108.23a.89.89,0,0,0,1.13.66,24.63,24.63,0,0,1,9.94-.88,25.64,25.64,0,0,1,5.47,1.57.63.63,0,0,0,.85-.75h0a3,3,0,0,0-1.85-2,26,26,0,0,0-7.58-1.69c-4.93-.28-7.26.9-7.26.9l-.41,1.1-.12-1h-.63Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.15,106.25a.63.63,0,0,1-.94.56,17.66,17.66,0,0,0-5.89-1.84,25.84,25.84,0,0,0-4-.14,1,1,0,0,1-1-1.08h0a1,1,0,0,1,.59-.8,11.75,11.75,0,0,1,4.9-.6,11.08,11.08,0,0,1,5.29,1.74l.39,1.3.08-1.24h.66Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "440448ad-8575-4ab3-bc81-b5e473c299a4",
    "data-name": "<Path>",
    d: "M599.54,67.84c-7.42,0-16.14,2.48-20.75,7a4.81,4.81,0,0,0-1.62,3.8,17.59,17.59,0,0,0-6,12.08A17.17,17.17,0,0,0,573,99.22a27.18,27.18,0,0,1,6.8-15.8,20.64,20.64,0,0,0,12,5.41,14.47,14.47,0,0,0,9.55-2.93s5.83-4.7,10.18-1.71c0,0,5.45,3.21,1.51,9.93a18.18,18.18,0,0,0-.41,2.26,11.16,11.16,0,0,0,7.95,11.47,16.7,16.7,0,0,0-2,8.65l4.22,1.41s.08-7.21,4.62-8.12c0,0,4,1.24,5.22,1.7a34.21,34.21,0,0,0,2.57-13.7c0-.76.74-13-3-18.11a7.71,7.71,0,0,0-5-3.05C621,70,610.68,67.82,599.54,67.84Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.37,112.6a14.55,14.55,0,0,1-4.81,12.25c-3.28,2.62-6.45,1.37-7.08-2.78a14.55,14.55,0,0,1,4.81-12.25C629.58,107.2,632.75,108.45,633.37,112.6Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.81,114.44s2.29-2.08,3.91-3.52c.87-.77,2.2,1.44,1.34,4.42-.3,1-1.13,4.94-3.43,6.87,0,0-.62.55-.54,0,.17-1.21-.71-1.12-.55-1.83a2.77,2.77,0,0,1,.64-1.2s.67-.46.75-2.28-1.09-2.66-1.54-2.66A1,1,0,0,0,625.81,114.44Z",
    style: {
      fill: "#b7835f",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.5,109.11a8.06,8.06,0,0,1,.92-2.29c.42-.37,2.25,0,6.71,5.17s1,3.54,1,3.54S576.62,114.53,574.5,109.11Z",
    style: {
      fill: "#b7835f",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.07,109.24s2.33,5.49,10.3,6.58",
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.10703858639007px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.26,116.74a11.77,11.77,0,0,1,4-3.5c2-1.2,11-6.42,10.14-.56,0,0-1.7,2.58-6.59,3.93S595.26,116.74,595.26,116.74Z",
    style: {
      fill: "#b7835f",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.67,112.66s-4.55,5.66-14.26,4.28",
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.10703858639007px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.29,199.91s15.06,100.23-2.44,149.23l-31.68-12.6s2.33-40.58-5.67-77.08l17.67-38.67Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.5,259.45a2.93,2.93,0,0,0-2.83,1.42c-.92,1.67-1.42,5.83-1,9.25s2.14,22.72,3.39,50.59l6.78-3.34S653.92,283,648.5,259.45Z",
    style: {
      fill: "#120667",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.75,301.86s-4.58,28.25.42,43.25,23.67,16,31.67,8-5-44.67-5-44.67Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.4,311.62a.63.63,0,0,1-.91-.31c-1.09-2.74-4.83-13-1.2-15.61,8.83-6.42,22.5-9.83,22.5-9.83l9-2.46a.63.63,0,0,1,.75.87c-.84,1.76-3.18,5-9.39,6.41a.64.64,0,0,0-.49.52l-1.34,9a.63.63,0,0,1-.31.45Z",
    style: {
      fill: "#9e684d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.81,272.46l5.49,12,.23,15.53,4.59-6.51s-2.8-3.11-2.94-4.84a13.77,13.77,0,0,1,.47-5.72.71.71,0,0,1,1.27-.15l7.41,11.32-6.48,11.6a7.85,7.85,0,0,1-4.59,3.69c-4.55,1.37-12.86,3.8-15.62,4.07C662,315,655.41,309,652.8,305a6.73,6.73,0,0,1,.25-7.86c2.46-3.09,8.19-5.39,21.46,2.4l1.83-11.08s-.67-2.88-.88-4.75a4.56,4.56,0,0,1,1.19-3.36.33.33,0,0,1,.55.09l2.57,6.47.26,13.22L682.35,284s-4.26-6.42-2.71-10a.39.39,0,0,1,.69,0l6.39,9.91.62,15,1.57-15s-4.43-9-2-11.5A.58.58,0,0,1,687.81,272.46Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.79,224.41s-7-16.37-14.12-26.5c0,0-3-3.94-3.62-1.44s.88,7.56,2.5,10.06,8.38,9.75,14,25.13C549.54,231.66,550.29,226.91,550.79,224.41Z",
    style: {
      fill: "#120667",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.47,311.9s2.78,10,3.53,14.63.17,7.83-.5,9.17-2-1.5-2.17-2.42c0,0-.9-7.4-5.07-20.31Z",
    style: {
      fill: "#120667",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.42,195.53s-4.62,34.38-2.25,50l-21.37-9.25,11.38-46.62,13.25,2Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.42,195.53s-4.62,34.38-2.25,50l-21.37-9.25,11.38-46.62,13.25,2Z",
    style: {
      fill: "#5333ed",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.18,158s8.32,14.08,27.32,10.75c0,0,6.42-1.37,10.17-3.94a3.26,3.26,0,0,0,1.15-1.35V143.41s11.94,3.64,13.1,12.13c.49,3.58-2.58,6.46,1.38,13,2.11,3.48,2.13,12.75-2,16.42-5.07,4.56-17,13.33-31.67,9.33A69.61,69.61,0,0,0,600.33,222c-.6,11.54-2.33,50.5-2.33,50.5l-29.33-18.25V207.36s.25-19.71,9.75-33.58c0,0-2.5-9.75.42-13.67s3.25-6.5,3.25-6.5.45-5,4.2-6.14c0,0,.93.27,1.84.43Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.42,173.78s5.17,9.92,15.5,13.33c0,0-11,1.85-20.09-4.68A42.32,42.32,0,0,1,578.42,173.78Z",
    style: {
      fill: "#5333ed",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.75,167.2s-2.81,8.51-16.31,13.31a.5.5,0,0,0-.15.86,3.76,3.76,0,0,0,2.08.74,18.53,18.53,0,0,1-3.21,1.83,22,22,0,0,0,19.5-13.83,10.32,10.32,0,0,1-1.58.42A3.17,3.17,0,0,0,637.75,167.2Z",
    style: {
      fill: "#5333ed",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582,153.84s-.47,13,7.13,16.39a1,1,0,0,1,.5,1.13h0a1,1,0,0,1-1.17.66c-2.31-.64-8.18-3.25-8.58-13.43Z",
    style: {
      fill: "#5333ed",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.82,163.51s2.18-3.65,2.27-5.15c0,0,.24-2.1-2.26-4.81Z",
    style: {
      fill: "#5333ed",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.18,158a5.45,5.45,0,0,1-1-3.27,6.4,6.4,0,0,1,.94-4Z",
    style: {
      fill: "#5333ed",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.11,128.78c-.42,1.86,1.86,2.46,4.68,2.12l.93-15.38a.38.38,0,0,0-.74-.16C586.46,119.39,583.43,127.4,583.11,128.78Z",
    style: {
      fill: "#b7835f",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M616.59,374c2.34-19.65,19.79-31.36,19.79-31.36h0c4.39-3.29,11.29-5.42,19-5.42a41.18,41.18,0,0,1,5,.3c.45-4.57,1.38-12.93,2.29-20.26,3.52-28.32,28.53-45.21,28.53-45.21h0c6.33-4.75,16.27-7.81,27.45-7.81,11.37,0,21.46,3.16,27.77,8a74.16,74.16,0,0,1,7.83,5.91,44.72,44.72,0,0,1,15.24-2.55c9.37,0,17.68,2.61,22.88,6.63,25,16.42,23.49,39.81,23.49,39.81,0,12.35-14.46,22.74-34.14,25.83a12.34,12.34,0,0,0-9,6.78c-6.81,13.53-28.43,23.42-54,23.42a96.6,96.6,0,0,1-11.63-.7c-9,.43-13.38,4.71-14.89,6.58-5.44,8.67-19.82,14.87-36.72,14.87-21.56,0-39-10.09-39-22.55A13.3,13.3,0,0,1,616.59,374Z",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "url(#cc24e7fb-140f-40f6-b4fd-5d5c0604e576)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.44,272.29c30.3,19.93,28.51,48.32,28.51,48.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.43,337.22c7.89,0,14.88,2.19,19.26,5.58a49.92,49.92,0,0,1,7.69,6.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgManinPeace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dist/static/media/manin-peace.82b239db01cbb7d9a39271b9017ef990.svg";